/** @module playerData */

export const playerColors = [
  "39, 35, 156",
  "35, 156, 45",
  "201, 39, 34",
  "0, 0, 0"
];

export const aiPlayers = {
  Corvus: {
    name: "Corvus",
    cautious: 2,
    social: 1,
    chaotic: 1
  },
  Graecus: {
    name: "Graecus",
    cautious: 1,
    social: 2,
    chaotic: 1
  },
  Cassia: {
    name: "Cassia",
    cautious: 1,
    social: 1,
    chaotic: 2
  },
  Severus: {
    name: "Severus",
    cautious: 3,
    social: 2,
    chaotic: 0
  },
  Aurelia: {
    name: "Aurelia",
    cautious: 0,
    social: 3,
    chaotic: 2
  },
  Proculus: {
    name: "Proculus",
    cautious: 2,
    social: 0,
    chaotic: 3
  }
};
